import React from "react";
import { Linkedin, Twitter, Facebook, Instagram, ArrowUp } from "lucide-react";
import Logo from "./Logo";
import { footerLinks, company } from "../mock/mock";

const Footer = () => {
  const top = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const socials = [Linkedin, Twitter, Facebook, Instagram];
  return (
    <footer className="bg-[#0A0A0A] text-[#F4F1EA]">
      {/* big infinity marquee */}
      <div className="overflow-hidden border-b-2 border-[#F4F1EA]/25 py-6 marquee-pause">
        <div className="flex items-center w-max animate-marquee">
          {Array(8).fill(0).map((_, i) => (
            <span key={i} className="display text-4xl md:text-6xl font-extrabold uppercase px-8 flex items-center gap-8 whitespace-nowrap">
              Let's Build <span style={{ color: "var(--accent)" }}>∞</span>
            </span>
          ))}
        </div>
      </div>

      <div className="container-x pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b-2 border-[#F4F1EA]/25">
          <div className="lg:col-span-2">
            <Logo dark />
            <p className="mt-5 text-sm text-[#F4F1EA]/60 leading-relaxed max-w-sm">
              A one-in-a-billion digital transformation partner delivering AI-powered software engineering,
              IT staffing, and cloud solutions for global enterprises.
            </p>
            <div className="flex gap-3 mt-6">
              {socials.map((Icon, i) => (
                <button key={i} onClick={top} className="w-11 h-11 border-2 border-[#F4F1EA] flex items-center justify-center hover:bg-[#F4F1EA] hover:text-[#0A0A0A] transition-colors">
                  <Icon size={18} />
                </button>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="mono text-[12px] font-bold uppercase tracking-widest mb-4 text-[#F4F1EA]/50">{title}</h4>
              <ul className="space-y-3">
                {links.map((l) => (
                  <li key={l}>
                    <button onClick={top} className="text-sm text-[#F4F1EA]/80 hover:text-[#F4F1EA] hover:pl-1 transition-all">{l}</button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="mono text-[12px] uppercase tracking-wide text-[#F4F1EA]/50">
            © {new Date().getFullYear()} {company.name} — Proud partner of VLink
          </p>
          <button onClick={top} className="flex items-center gap-2 mono text-[12px] uppercase tracking-widest text-[#F4F1EA]/70 hover:text-[#F4F1EA] transition-colors">
            Back to top <ArrowUp size={15} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
